/** The shortcut that toggles the panel, as the platform writes it. */
export const LAUNCHER_SHORTCUT_LABEL =
  typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform)
    ? '⌘J'
    : 'Ctrl J';

/** True for the keypress that toggles the Ask Moo panel: ⌘J on macOS,
 *  Ctrl+J elsewhere, with no other modifier. Auto-repeat while the keys are
 *  held does not count, so holding the shortcut toggles once instead of
 *  flipping the panel open and closed on every repeat. */
export function isLauncherShortcut(
  e: Pick<
    KeyboardEvent,
    'key' | 'metaKey' | 'ctrlKey' | 'shiftKey' | 'altKey' | 'repeat'
  >
): boolean {
  if (e.repeat) return false;
  if (!(e.metaKey || e.ctrlKey) || e.shiftKey || e.altKey) return false;
  return e.key.toLowerCase() === 'j';
}
